import Auth from '../../modules/Authentication'
import {apiUrl} from '../../variables'
import {handleErrors, handleResponse} from '../../modules/Utils'

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}
const auth = new Auth()

export const BASApi = {
  list: () => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}bas?select=*`, {headers})
      .then(handleErrors)
      .then(handleResponse)
  },

  generate: data => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}bas/generate`, {
      headers: headers,
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },

  create: data => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}bas/`, {
      headers: headers,
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
  update: data => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}bas/`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },

  remove: data => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}bas/`, {
      headers: headers,
      method: 'DELETE',
      body: JSON.stringify(data),
    }).then(handleErrors)
    // .then(handleResponse)
  },
  //
  // getLinesByRFQ: key => {
  //   headers['authorization'] = `Bearer ${auth.getAccessToken()}`
  //   return fetch(`${apiUrl}rfq/lines/${key}`, {headers})
  //     .then(handleErrors)
  //     .then(handleResponse)
  // },
  //
  operation: data => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}bas/action`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
  //
  // files: data => {
  //   headers['authorization'] = `Bearer ${auth.getAccessToken()}`
  //   return fetch(`${apiUrl}rfq/files`, {
  //     headers,
  //     method: 'POST',
  //     body: JSON.stringify(data),
  //   })
  //     .then(handleErrors)
  //     .then(handleResponse)
  // },
  // lines: {
  //   list: () => {
  //     headers['authorization'] = `Bearer ${auth.getAccessToken()}`
  //     return fetch(`${apiUrl}rfq/lines/`, {headers})
  //       .then(handleErrors)
  //       .then(handleResponse)
  //   },
  //   create: data => {
  //     headers['authorization'] = `Bearer ${auth.getAccessToken()}`
  //     return fetch(`${apiUrl}rfq/lines/`, {
  //       headers: headers,
  //       method: 'POST',
  //       body: JSON.stringify(data),
  //     })
  //       .then(handleErrors)
  //       .then(handleResponse)
  //   },
  //   update: data => {
  //     headers['authorization'] = `Bearer ${auth.getAccessToken()}`
  //     return fetch(`${apiUrl}rfq/lines/`, {
  //       headers: headers,
  //       method: 'PATCH',
  //       body: JSON.stringify(data),
  //     })
  //       .then(handleErrors)
  //       .then(handleResponse)
  //   },
  //   remove: data => {
  //     headers['authorization'] = `Bearer ${auth.getAccessToken()}`
  //     return fetch(`${apiUrl}rfq/lines/`, {
  //       headers: headers,
  //       method: 'DELETE',
  //       body: JSON.stringify(data),
  //     })
  //       .then(handleErrors)
  //       .then(handleResponse)
  //   },
  // },
}
